
export const search = (target) => {
    const parsed = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const fixedHeader = select("#fixed-header")
    
    if(!fixedHeader.classList.contains('modo-pesquisa')){
        fixedHeader.classList.add('modo-pesquisa')
    }

    let categorias = selectAll('.categoria') 
 
    let hiddenCat = 0
    categorias.forEach((categoria) => {
        let produtos = categoria.querySelectorAll('.produto')

        let hiddenProd = 0
        produtos.forEach((produto) => {
            let descricao = produto.querySelector('.produto-info-nome').textContent
            //Retira todos os caracteres especiais
            /**/
            descricao = parsed(descricao)
            //Transforma em letras pequenas
            /**/
            descricao = descricao.toLowerCase()

            //Faz o mesmo para os valores do input
            let inputValue = parsed(target.value).toLowerCase()

            if (!descricao.includes(inputValue) && inputValue != '') {
                produto.style.display = 'none'
                hiddenProd++
            } else {
                produto.style.display = ''
            }
        })

        if (hiddenProd === produtos.length) {
            categoria.style.display = 'none'
            hiddenCat++
        } else {
            categoria.style.display = ''
        }
    })

    if (hiddenCat === categorias.length) {
        const exist = select('#not-found')
        if (!exist) {
            let notFound = document.createElement('div')
            notFound.id = 'not-found'
            notFound.textContent = 'Nenhum produto encontrado'
            notFound.style = 'font-style: italic;color: #908b8b;'
            select('.cardapio-container .content').appendChild(notFound)
        }
    } else {
        const notFound = select('#not-found')
        if (notFound) {
            notFound.remove()
        }
    }
}